/* eslint-disable object-curly-newline */
import React from 'react';
import { CommonColumn } from '@bingads-webui-grid/campaign-details-list';

export const useCommonColumn = () => {
  const renderHeaderWithPopup = (props) => {
    // for the elements which are sortable and have help-icon, they can cause the a11y bug "Ensures interactive controls are not nested"
    // to solve this bug, we should remove the "role = button" attribute for the header elements
    const { column, columnIndex } = props;
    const { helpId, sortable } = column;
    if (sortable && helpId) {
      const headerCell = document.querySelectorAll('.ms-DetailsHeader-cellTitle')[columnIndex - 1];
      if (headerCell) {
        headerCell.removeAttribute('role');
        headerCell.style.cursor = 'pointer';
      }
    }
    return (
      <CommonColumn column={props.column} alignWithCampaignUI withCustomizedSortIcon={props.column.sortable} />
    );
  };

  return {
    renderHeaderWithPopup,
  };
};
